import { Component, ErrorInfo, ReactNode } from 'react';

interface Props { children: ReactNode; }
interface State { hasError: boolean; error: Error | null; }

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 bg-red-50 border border-red-200 rounded-lg m-4">
          <h2 className="text-lg font-bold text-red-700 mb-2">Something went wrong</h2>
          <pre className="text-sm text-red-600 whitespace-pre-wrap">{this.state.error?.message}</pre>
          <pre className="text-xs text-red-400 mt-2 whitespace-pre-wrap">{this.state.error?.stack}</pre>
          <button onClick={() => this.setState({ hasError: false, error: null })}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 text-sm">
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
